var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['app-carousel-nav-button', ("btn-" + _vm.type)],attrs:{"id":_vm.id,"aria-label":_vm.ariaLabel,"type":"button"}})}
var staticRenderFns = []

export { render, staticRenderFns }